// More robust version that waits for the app
function updateCustomCounter() {
  const appCounterValue = document.querySelector('#Units\\ shipped .els-cup-w-val');
  const jiadeCounterValue = document.querySelector('.jiade-sold');
  const myCounter = document.querySelector('.my-custom-counter');
  
  if (appCounterValue && jiadeCounterValue && myCounter) {
    const jiadeCount = parseInt(jiadeCounterValue.textContent, 10);
    const shideCount = parseInt(appCounterValue.textContent, 10);
    myCounter.textContent = jiadeCount + shideCount;
    console.log('Counter updated:', soldCount ); // For debugging
    return true;
  }
  return false;
}

// Try multiple times as the app loads
let attempts = 0;
const maxAttempts = 20;

const checkInterval = setInterval(function() {
  attempts++;
  
  if (updateCustomCounter()) {
    // Success! Now update every second
    setInterval(updateCustomCounter, 1000);
    clearInterval(checkInterval);
  } else if (attempts >= maxAttempts) {
    console.log('Sales CountUp element not found');
    clearInterval(checkInterval);
  }
}, 500); // Check every 500ms
